import { AccountsService } from "@services/accounts.service";
import { PermissionResolverService } from "./permission-resolver.service";

/**
 * WS-2403 `section.calendar.*` keys that replace legacy reservation capability tokens.
 */
const LEGACY_CALENDAR_ACTION_TO_SECTION_EDIT: Record<string, string> = {
  RESCHEDULE_RESERVATION: "section.calendar.rischedulazione.edit",
  CHANGE_STATUS_RESERVATION: "section.calendar.cambio_stato.edit",
};

/** WS-2403 action-only: Calendario — Export (`section.calendar.export.edit`). */
export function calendarExportAllowed(accounts: AccountsService): boolean {
  return accounts.hasPermission("section.calendar.export.edit");
}

/** WS-2403 action-only: Vendite — Export (`section.sales.export.edit`). */
export function salesExportAllowed(accounts: AccountsService): boolean {
  return accounts.hasPermission("section.sales.export.edit");
}

function calendarActionAllowed(accounts: AccountsService, token: string): boolean {
  if (accounts.hasPermission(token)) {
    return true;
  }
  const sectionEdit = LEGACY_CALENDAR_ACTION_TO_SECTION_EDIT[token];
  return sectionEdit ? accounts.hasPermission(sectionEdit) : false;
}

/**
 * Reservation detail `PERMISSION_MAP_WITH_FIELDS` groups: supports legacy tokens,
 * `[[WRITE,"CALENDAR"]]` via {@link PermissionResolverService.canEditSection}(`section.calendar`),
 * and granular `section.calendar.*.edit` for specific actions.
 */
export function evaluateReservationDetailPermissionGroups(
  accounts: AccountsService,
  resolver: PermissionResolverService,
  permissionGroups: string[][]
): boolean {
  return permissionGroups.some((group) => {
    if (group.length === 2 && group.includes("WRITE") && group.includes("CALENDAR")) {
      return resolver.canEditSection("section.calendar");
    }
    return group.every((token) => calendarActionAllowed(accounts, token));
  });
}
